import { render, staticRenderFns } from "./StoreOrder.vue?vue&type=template&id=169c13aa&scoped=true&"
import script from "./StoreOrder.vue?vue&type=script&lang=js&"
export * from "./StoreOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169c13aa",
  null
  
)

export default component.exports